var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-mobile"},[_c('ContainerInner',{staticClass:"header-mobile__inner"},[_c('ElementBrand',{staticClass:"header-mobile__brand"}),_c('ElementToggle',{staticClass:"header-mobile__toggle",attrs:{"active":_vm.activeToggle},on:{"click":_vm.handleToggle}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }